<template>
  <div id="map"></div>
</template>

<style>
@import '../../node_modules/mapbox-gl/dist/mapbox-gl.css';
</style>

<script>
import mapcatJson from '../../public/assets/mapcat.json';
import mapboxgl from 'mapbox-gl';
import config from '../helpers/configProvider';

export default {
  name: 'Map',

  data() {
    let root =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '') +
      (config.getEnv(config.enum.VUE_APP_BASE_PATH) || '');
    root = config.getEnv(config.enum.VUE_APP_TILE_URL) || root;

    return {
      root: root,
      tileUrl: root + '/tile/{z}/{x}/{y}.pbf',
      map: undefined
    };
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = undefined;
    }
  },
  mounted() {
    mapcatJson.sources['composite'].tiles = [this.tileUrl];
    mapcatJson.sources['composite.poi'].tiles = [this.tileUrl];
    mapcatJson.sources['composite.shape'].tiles = [this.tileUrl];

    // current year in attribution
    for (const source of Object.keys(mapcatJson.sources)) {
      if (mapcatJson.sources[source].attribution) {
        mapcatJson.sources[source].attribution = mapcatJson.sources[source].attribution.replace(
          /© \d\d\d\d /,
          `© ${new Date().getFullYear()} `
        );
      }
    }

    mapcatJson.sprite = this.root + '/assets/sprite';
    mapcatJson.glyphs = this.root + '/assets/fonts/{fontstack}/{range}.pbf';
    this.map = new mapboxgl.Map({
      container: 'map',
      vector: true,
      zoom: 11,
      minZoom: 3,
      maxZoom: 22,
      center: [19.035, 47.4835],
      style: mapcatJson,
      hash: true,
      attributionControl: true,
      zoomControl: true,
      dragRotate: true
    });
    let zoomControl = new mapboxgl.NavigationControl({
      position: 'top-right'
    });
    let scaleControl = new mapboxgl.ScaleControl({
      position: 'bottom-left',
      maxWidth: 100,
      unit: 'metric'
    });
    this.map.addControl(zoomControl);
    this.map.addControl(scaleControl);
    this.map.on('contextmenu', (e) => {
      var features = this.map.queryRenderedFeatures(e.point);
      // eslint-disable-next-line no-console
      console.log(
        'here',
        features.map((f) => {
          return { prop: f.properties, layer: f.layer };
        })
      );
    });
    this.$emit('hasMap', this.map);
  }
};
</script>
